import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export default function EditApprovedShiftModal({ show, onHide, shift, templates = [], onSave, saving }) {
  const [templateId, setTemplateId] = useState('');
  const [isQc, setIsQc] = useState(false);

  useEffect(() => {
    if (shift) {
      setTemplateId(shift.template_id || '');
      setIsQc(shift.is_qc || false);
    } else {
      setTemplateId('');
      setIsQc(false);
    }
  }, [shift]);

  const handleSave = () => {
    if (!shift) return;
    onSave(shift.id, { template_id: templateId || null, is_qc: isQc });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>Sửa ca đã duyệt</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!shift ? (
          <div className="text-muted">Không có dữ liệu</div>
        ) : (
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Cấu hình ca</Form.Label>
              <Form.Select
                value={templateId}
                onChange={(e) => setTemplateId(e.target.value)}
              >
                <option value="">Giữ nguyên</option>
                {templates.map((t) => (
                  <option
                    key={t.id}
                    value={t.id}
                  >
                    {t.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Ca QC</Form.Label>
              <div className="d-flex align-items-center gap-2">
                <Form.Check
                  type="switch"
                  id="edit-shift-is-qc"
                  checked={isQc}
                  onChange={(e) => setIsQc(e.target.checked)}
                  label={isQc ? 'Ca QC' : 'Không phải ca QC'}
                />
              </div>
              <Form.Text className="text-muted">
                Ca QC có thể review task với video bằng chứng (5-10s).
              </Form.Text>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={saving}
        >
          Hủy
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={saving || !shift}
        >
          Lưu
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


